<template>
  <!-- Render two overlapped "app window" glyphs (copy-style) -->
  <!-- Rear stroke is muted; front uses an inset plate (not full bbox bg) so white doesn’t spill onto the exposed rear window. -->
  <span class="relative isolate inline-block origin-center scale-[0.86]">
    <IconLucideAppWindow class="absolute inset-0 z-0 h-full w-full" />
    <span
      class="pointer-events-none absolute inset-0 z-1"
      :style="{ transform: 'translate(22%, 22%)' }"
      aria-hidden="true"
    >
      <span class="absolute inset-x-[10%] top-[24%] bottom-[10%] rounded-[2px] bg-white" />
    </span>
    <IconLucideAppWindow
      class="absolute inset-0 z-10 h-full w-full"
      :style="{ transform: 'translate(22%, 22%)' }"
    />
  </span>
</template>
